
const   PROJECT_MEMBER_GET_LIST        = '/api/project-members/get-list'
const   PROJECT_MEMBER_GET             = '/api/project-members/get'



export default {
    getList(axios, condition, success, fail) {
        let query = {
            params: condition
        }
        axios.get(PROJECT_MEMBER_GET_LIST, query)
            .then((response) => {
                let data = response.data
                success(data)
            })
            .catch((error) => {
                fail(error)
            })
    },
    get(axios, params, success, fail) {
        let query = {
            params: params
        }
        axios.get(PROJECT_MEMBER_GET, query)
            .then((response) => {
                let data = response.data
                success(data)
            })
            .catch((error) => {
                fail(error)
            })
    },

   
   
   
   
}